module.exports = __webpack_public_path__ + "fd94c272f715142aabefd4926839be73.pdf";